<template>
    <div class="rq-avatar-edit">
        <div class="cropper-container">
            <VueCropper
                ref="cropper"
                class="circle-cropper"
                :img="clipperOptions.img"
                :mode="clipperOptions.mode"
                :fixed-number="clipperOptions.fixedNumber"
                :fixed-box="clipperOptions.fixedBox"
                :fixed="clipperOptions.fixed"
                :original="clipperOptions.original"
                :can-move-box="clipperOptions.canMoveBox"
                :can-move="clipperOptions.canMove"
                :center-box="clipperOptions.centerBox"
                :auto-crop="clipperOptions.autoCrop"
                :auto-crop-width="clipperOptions.autoCropWidth"
                :auto-crop-height="clipperOptions.autoCropHeight"
                :output-type="clipperOptions.outputType"
                :output-size="clipperOptions.outputSize"
                :can-scale="clipperOptions.canScale"
                :info="clipperOptions.info"

                @real-time="this.onCropperChange"
            >
            </VueCropper>
            <div class="cropper-actions">
                <CommonButton
                    :icon="{
                        iconName: 'file-upload',
                        style: {
                            height: 20,
                            width: 20,
                        }
                    }"
                    title="Upload"
                    text=""
                    :enabled="true"
                    :showText="true"
                    @click="StartUpload"
                />
                <input
                    ref="upload"
                    type="file"
                    id="uploadFile"
                    style="clip:rect(0 0 0 0);"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                    @change="UploadImage"
                />
                <CommonButton
                    :icon="{
                        iconName: 'plus',
                        style: {
                            height: 20,
                            width: 20,
                        }
                    }"
                    title="Zoom In"
                    text=""
                    :enabled="true"
                    :showText="true"
                    @click="changeScale(1)"
                />
                <CommonButton
                    :icon="{
                        iconName: 'minus',
                        style: {
                            height: 20,
                            width: 20,
                        }
                    }"
                    title="Zoom Out"
                    text=""
                    :enabled="true"
                    :showText="true"
                    @click="changeScale(-1)"
                />
            </div>
        </div>
        <div class="cropper-preview circle">
            <label class="cropper-preview-header">
                Preview
            </label>
            <img height="128" width="128" :src="clippedImage" alt="">
        </div>
    </div>
</template>

<script>
import 'vue-cropper/dist/index.css'
import { VueCropper }  from 'vue-cropper'
import CommonButton from '@/components/CommonButton';

export default {
    name: 'AvatarEdit',
    components: {
        VueCropper,
        CommonButton,
    },
    props: {
    },
    watch: {
        avatarInformation (newValue, oldValue) {
            this.$emit('action', { name: 'Updated', data: this.avatarInformation } );
        }
    },
    data() {
        return {
            popup: false,
            clippedImage: '',
            avatarPreview: {},

            avatarBlob: '',
            avatarBlobDataUri: '',
            avatarDataUrl: '',

            forceClipDebounced: () => {},
            clipperOptions: {
                img: "",//"data:image/jpg;base64,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",
                
                // https://github.com/xyxiao001/vue-cropper/blob/master/english.md

                outputSize: 1,          // Cropper quality
                full: true,             // Use original scale

                fixed: true,            // If true, fixedNumber is a ratio. Otherise, fixedNumber is static pixel width : height.
                fixedNumber: [1, 1],    // width : height
                fixedBox: true,        // Locks the cropper size.

                original: true,        // Rendered in raw size

                canMoveBox: true,       // Cropper can move.
                canMove: true,         // Image can move.
                centerBox: true,        // Restrict cropper to contents of image.

                autoCrop: true,         // Generates screenshot box.
                autoCropWidth: 128,      // Cropper width.
                autoCropHeight: 128,     // Cropper height.

                outputType: "jpg",
                mode: "contain",        // Determines image stretching.... contain , cover, 100px, 100% auto
                canScale: true,         // Allow scroll wheel to zoom.
                info: true,             // Cropper size information.
            }
        }
    },
    computed: {
        avatarInformation() {
            return {
                blob: this.avatarBlob,
                blobDataUri: this.avatarBlobDataUri,
                dataUrl: this.avatarDataUrl,
            }
        }
    },
    methods: {
        // Download(type) {
        //     this.forceClipDebounced();

        //     var aLink = document.createElement('a')
        //     aLink.download = 'demo'

        //     if (type === 'blob') {
        //         this.$refs.cropper.getCropBlob((data) => {
        //             aLink.href = window.URL.createObjectURL(data);
        //             aLink.click();
        //         });
        //     }
        //     else {
        //         this.$refs.cropper.getCropData((data) => {
        //             aLink.href = data;
        //             aLink.click();
        //         })
        //     }
        // },
        StartUpload() {
            this.$refs.upload.click();
        },
        Popup() {
            this.forceClipDebounced();
            this.togglePopup();
        },
        UploadImage(e) {
            var file = e.target.files[0]
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                return false
            }
            var reader = new FileReader()
            reader.onload = (e) => {
                let data;
                if (typeof e.target.result === 'object') {
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.clipperOptions.img = data;
            }
            reader.readAsArrayBuffer(file);
        },
        changeScale(num) {
            const self = this;

            num = num || 1
            self.$refs.cropper.changeScale(num)
        },
        forceClip() {
            const self = this;

            self.$refs.cropper.getCropBlob((data) => {
                self.avatarBlob = data;
                self.avatarBlobDataUri = window.URL.createObjectURL(data);

                self.clippedImage = self.avatarBlobDataUri;
            });

            this.$refs.cropper.getCropData((data) => {
                self.avatarDataUrl = data;
            });
        },
        onCropperChange(data) {
            this.avatarPreview = data;
            this.forceClipDebounced();
        },
        togglePopup() {
            this.popup = !this.popup;
        },
    },
    created() {
        // Access to DATA/COMPUTED and "events". No DOM mounted or rendered.
        // Access to DATA via "this".
        // Access to COMPUTED via property name directly.
        const self = this;

        self.forceClipDebounced = _.debounce(() => {
            self.forceClip();
        }, 250);
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    #uploadFile {
        display: none;
    }
</style>